import React from 'react';

import { search_page_path } from '@routes';

const SEARCH_EXAMPLES = [
  'Most promising startups',
  'Artificial intelligence regulation',
  'The future of EV batteries',
  'Crypto & the SEC',
  'Venture capital trends',
];

const SearchExamples = () => (
  <div className="px-16">
    <div className="mx-auto mt-48 max-w-[600px]">
      <h2 className="m-0 border-0 border-b border-solid border-grayscale-gray text-body-lg font-bold">
        Example searches:
      </h2>
      <ul className="m-0 mt-12 list-none space-y-8 pl-4">
        {SEARCH_EXAMPLES.map((query) => (
          <li key={query}>
            <SearchExampleLink query={query} />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const SearchExampleLink = ({ query }) => (
  <a
    href={search_page_path({ query })}
    className="m-0 transition-colors hover:text-primary-magenta"
  >
    <span aria-hidden="true">{'> '}</span>
    <span className="sr-only">Search results for </span>
    <span className="text-body-sm italic">{query}</span>
  </a>
);

export default SearchExamples;
